import dynamic from 'next/dynamic';

import { toPX } from '#app/helpers/toPX';
import useWindowSize from '#app/hooks/useWindowSize';

import {
  typo_48,
  typo_32,
  typo_24,
  typo_16
} from '../../../UI/atoms/typography/typography.module.scss';
import styles from './index.module.scss';

const ImageText = dynamic(() => import('../../../templates/image-text'));

const Typography = dynamic(() => import('../../../UI/atoms/typography/typography'));
const Button = dynamic(() => import('../../../UI/molecules/button/button'));
const MiniCourse = dynamic(() => import('../../../UI/molecules/mini-course'));

const Path = ({
  title,
  description,
  resume,
  margin,
  padding,
  background = 'white',
  mainColor,
  backgroundColorWrapper,
  backgroundColorContainer
}) => {
  const { isDesktop } = useWindowSize();

  return (
    <section
      className={styles.wrapper}
      style={{
        background: background && background,
        // Margin
        marginTop: margin && margin.top && toPX(isDesktop, margin.top),
        marginRight: margin && margin.right && toPX(isDesktop, margin.right),
        marginBottom: margin && margin.bottom && toPX(isDesktop, margin.bottom),
        marginLeft: margin && margin.left && toPX(isDesktop, margin.left),
        // Padding
        paddingTop: padding && padding.top && toPX(isDesktop, padding.top),
        paddingRight: padding && padding.right && toPX(isDesktop, padding.right),
        paddingBottom: padding && padding.bottom && toPX(isDesktop, padding.bottom),
        paddingLeft: padding && padding.left && toPX(isDesktop, padding.left)
      }}
    >
      <div className={styles.container}>
        <Typography
          variant={typo_48}
          fontWeight={700}
          margin={{ left: [0, 20] }}
          center={isDesktop}
          tag="h2"
        >
          {title}
        </Typography>

        <Typography
          variant={typo_24}
          fontWeight={400}
          margin={{ left: [0, 20] }}
          center={isDesktop}
          tag="p"
        >
          {description}
        </Typography>

        <ImageText
          first="image"
          header={
            <Typography
              variant={typo_32}
              fontWeight={700}
              color={isDesktop ? mainColor : 'black'}
              center={isDesktop}
              tag="p"
            >
              {resume.title}
            </Typography>
          }
          footer={
            <Button
              type="redirect"
              href={'/rutas/programacion-con-minecraft'}
              variant="black"
              height={isDesktop ? '56px' : '48px'}
              width={isDesktop ? '279px' : '100%'}
              textOptions={{
                fontSize: [20, 20],
                lineHeight: [21, 21],
                fontWeight: 700
              }}
            >
              Descubrir esta ruta
            </Button>
          }
          video={{
            youtubeId: '89hoSSX7VLM',
            padding: {
              left: [25, 0],
              right: [25, 0]
            }
          }}
          padding={{
            top: [48, 48],
            right: [40, 20],
            bottom: [48, 48],
            left: [40, 20]
          }}
          margin={{ top: [32, 24], right: [0, 20], left: [0, 20] }}
          columnGap={[40, 0]}
          rowGap={[32, 24]}
          maxWidth="1062px"
          backgroundColorWrapper={backgroundColorWrapper}
          backgroundColorContainer={backgroundColorContainer}
          borderRadius={[12, 12]}
        >
          <Typography
            variant={typo_16}
            fontWeight={400}
            margin={{ bottom: [11, 11] }}
            color="black"
            tag="p"
          >
            {resume.description}
          </Typography>

          <Typography
            variant={typo_16}
            fontWeight={700}
            margin={{ bottom: [13, 13] }}
            color="black"
            tag="p"
          >
            Cursos en esta ruta:
          </Typography>

          {resume.list.map((item, idx) => (
            <MiniCourse key={idx} {...item} marginBottom={[8, 8]} />
          ))}
        </ImageText>
      </div>
    </section>
  );
};

export default Path;
